import { render } from "./LocationForm.vue?vue&type=template&id=6aa0b849"
import script from "./LocationForm.vue?vue&type=script&lang=js"
export * from "./LocationForm.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__